import { PrismicNextImage } from "@prismicio/next";
import Styles from "./BrandBanner.module.css";

const Default = ({ items }) => {
	return (
		<section className={Styles.wrapper}>
			<div
				className={Styles.container}
				data-contain='true'>
				{items.map((item, index) => (
					<PrismicNextImage
						field={item?.image}
						key={index}
					/>
				))}
			</div>
		</section>
	);
};

export default Default;
